const config: Record<string, any> = {
  /* NOTICE! 
      you need to manually add the title and the description for your app inside public/index.html
   */
  // To change the favicon, Head to public/favicon.svg and the replace the svg file with yours.
  // To change the logo, Head to src/assets/logo.png and the replace image with yours.
  lang: "en", // language of your website
  locale: "en_US", // locale of your website
  title: "Koii.X — Your Koii DApp",
  logoUrl: "https://raw.githubusercontent.com/koii-network/koii.X/main/.github/images/koii_logo.svg",
  description: "Create Koii DApp",
  canonical: "http://koii-x.vercel.app/", // Your production website link
  twitterName: "KoiiNetwork", // Twitter username
  telegramName: "KoiiNetwork", // Telegram username
  githubName: "KoiiNetwork", // Telegram username
  discordName: "KoiiNetwork", // Discord name
  companyName: "Koii",
  companyLogoUrl: "https://wallpaperaccess.com/full/388350.png",
  markdownIdentifier: /^---/,
  companyDetails: "Company / Project details address were company is based or any other relevant information"
};

export default config;
